/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const PROFILEVIEWDETAILBYUSERID= createAsyncThunk(
  "ProfileviewDetailsByUserId/ProfileviewDetailsByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const ProfileviewDetailsByUserIdSlice = createSlice({
  name: "ProfileviewDetailsByUserIdSlice",
  initialState: {
    ProfileviewDetailsByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfProfileviewDetailsByUserId: (state) => {
        state.ProfileviewDetailsByUserId.loading = false
        state.ProfileviewDetailsByUserId.error = false
        state.ProfileviewDetailsByUserId.data = []
        state.ProfileviewDetailsByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(PROFILEVIEWDETAILBYUSERID.fulfilled, (state, action) => {
      state.ProfileviewDetailsByUserId = {
        ...state.ProfileviewDetailsByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PROFILEVIEWDETAILBYUSERID.pending, (state, action) => {
      state.ProfileviewDetailsByUserId = {
        ...state.ProfileviewDetailsByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PROFILEVIEWDETAILBYUSERID.rejected, (state, action) => {
      state.ProfileviewDetailsByUserId = {
        ...state.ProfileviewDetailsByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const ProfileviewDetailsByUserIdAction = {
    PROFILEVIEWDETAILBYUSERID,
};

export { ProfileviewDetailsByUserIdAction };
export default ProfileviewDetailsByUserIdSlice.reducer;
export const {setInitialStateOfProfileviewDetailsByUserId} = ProfileviewDetailsByUserIdSlice.actions